<template>
    <component :is="layout"></component>
</template>

<script>
import Signup from "@/layouts/public/signup";
import Landing from "@/layouts/public/landing";
import EngineDesigner from "@/layouts/engine-designer";
export default {
  components: {
    Signup,
    Landing,
    EngineDesigner,
  },
  computed: {
    matched: (vm) => vm.$route.matched,
    layout: (vm) =>
      vm.matched.find((r) => r.meta.layout)?.meta.layout,
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "Quicksand";
  src: url("~@/assets/fonts/Quicksand.ttf");
}

@font-face {
  font-family: "NG Grotesque 3";
  src: url("~@/assets/fonts/NG_Grotesque_web_1_Light.ttf");
}

@font-face {
  font-family: "Grotesque Bold";
  src: url("~@/assets/fonts/Grotesque-Bold.otf");
}
.v-application {
  [class*="text-"] {
    font-family: "Quicksand", sans-serif !important;
  }
  font-family: "Quicksand", sans-serif !important;

  .title-font-secondary {
    font-family: "NG Grotesque 3", sans-serif !important;
    font-size: 60px;
    font-weight: 900;
    color: #021d3e;
  }
  .app-width-limit {
    max-width: 1100px;
  }
  @media only screen and (max-width: 600px) {
    .title-font-secondary {
      font-size: 1.5rem;
    }
  }
  @media only screen and (max-width: 800px) {
    .title-font-secondary {
      font-size: 1.5rem;
    }
  }
}
</style>
